/* eslint-disable indent */
import React from "react";
import styles from "../stylesERv2.module.scss";

/**
 * Fila "Tipo de cambio referencia" al pie de la tabla — clonada del v1
 * (ER/index.js:4558-4674). Solo se muestra en modo "Ver en US$": una fila con el TC
 * del pais cuando se ve un pais solo, y dos filas (TC Chile / TC Peru) en modo region.
 */
export const TipoCambioTable = ({
  verEnDolares,
  verChileYPeru,
  mesesWindowed,
  eMs,
  eDolar,
  moneda,
  localString,
  pais,
  meses,
  monthsToShow,
  dolarMensual,
  dolarMensualOtroPais,
}) => (
  <>
    {/* Tipo de cambio referencia - al final de todo */}
    {verEnDolares && !verChileYPeru && (
      <>
        <tr style={{ height: "12px", backgroundColor: "transparent" }}>
          <td colSpan={14} style={{ padding: 0, border: "none" }} />
        </tr>
        <tr style={{ backgroundColor: "#333", fontStyle: "italic" }}>
          <td
            className={styles.conceptCell}
            style={{ textAlign: "left", color: "#fff", fontWeight: "400", fontSize: "0.85rem" }}
          >
            Tipo de cambio referencia
          </td>
          {mesesWindowed.map((_, index) => (
            <td
              key={index}
              className={styles.valueCell}
              style={{
                fontSize: "0.8rem",
                color: "#fff",
                fontWeight: "400",
                padding: "6px 4px",
                textAlign: "center",
              }}
            >
              {index < eMs ? (
                <span title={`Tipo de cambio ${mesesWindowed[index]}`}>
                  {moneda(pais)}
                  {eDolar[index]?.toLocaleString(localString(pais), {
                    minimumFractionDigits: pais === "Perú" ? 2 : 0,
                    maximumFractionDigits: pais === "Perú" ? 2 : 0,
                  })}
                </span>
              ) : (
                "-"
              )}
            </td>
          ))}
          <td style={{ backgroundColor: "#333" }} />
        </tr>
      </>
    )}
    {verEnDolares && verChileYPeru && (
      <>
        <tr style={{ height: "12px", backgroundColor: "transparent" }}>
          <td colSpan={14} style={{ padding: 0, border: "none" }} />
        </tr>
        <tr style={{ backgroundColor: "#333", fontStyle: "italic" }}>
          <td
            className={styles.conceptCell}
            style={{ textAlign: "left", color: "#fff", fontWeight: "400", fontSize: "0.85rem" }}
          >
            TC Chile (CLP/USD)
          </td>
          {meses.map((_, index) => (
            <td
              key={index}
              className={styles.valueCell}
              style={{
                fontSize: "0.8rem",
                color: "#fff",
                fontWeight: "400",
                padding: "6px 4px",
                textAlign: "center",
              }}
            >
              {index < monthsToShow ? (
                <span>
                  ${" "}
                  {(pais === "Chile" ? dolarMensual[index] : dolarMensualOtroPais[index])?.toLocaleString("es-CL", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </span>
              ) : (
                "-"
              )}
            </td>
          ))}
          <td style={{ backgroundColor: "#333" }} />
        </tr>
        <tr style={{ backgroundColor: "#444", fontStyle: "italic" }}>
          <td
            className={styles.conceptCell}
            style={{ textAlign: "left", color: "#fff", fontWeight: "400", fontSize: "0.85rem" }}
          >
            TC Perú (PEN/USD)
          </td>
          {meses.map((_, index) => (
            <td
              key={index}
              className={styles.valueCell}
              style={{
                fontSize: "0.8rem",
                color: "#fff",
                fontWeight: "400",
                padding: "6px 4px",
                textAlign: "center",
              }}
            >
              {index < monthsToShow ? (
                <span>
                  S/{" "}
                  {(pais === "Perú" ? dolarMensual[index] : dolarMensualOtroPais[index])?.toLocaleString("es-PE", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              ) : (
                "-"
              )}
            </td>
          ))}
          <td style={{ backgroundColor: "#444" }} />
        </tr>
      </>
    )}
  </>
);
